export default __webpack_public_path__ + "static/media/github_import.ef43a0cd.png";